import { render, staticRenderFns } from "./PiHoleTopQueries.vue?vue&type=template&id=1c221dfa&scoped=true"
import script from "./PiHoleTopQueries.vue?vue&type=script&lang=js"
export * from "./PiHoleTopQueries.vue?vue&type=script&lang=js"
import style0 from "./PiHoleTopQueries.vue?vue&type=style&index=0&id=1c221dfa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c221dfa",
  null
  
)

export default component.exports